var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4301 19.6989C14.2401 19.6989 14.0501 19.6289 13.9001 19.4789C13.6101 19.1889 13.6101 18.7089 13.9001 18.4189L19.4401 12.8789L13.9001 7.3389C13.6101 7.0489 13.6101 6.5689 13.9001 6.2789C14.1901 5.9889 14.6701 5.9889 14.9601 6.2789L21.0301 12.3489C21.3201 12.6389 21.3201 13.1189 21.0301 13.4089L14.9601 19.4789C14.8101 19.6289 14.6201 19.6989 14.4301 19.6989Z",
    fill: "#6374FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.33 13.6289H3.5C3.09 13.6289 2.75 13.2889 2.75 12.8789C2.75 12.4689 3.09 12.1289 3.5 12.1289H20.33C20.74 12.1289 21.08 12.4689 21.08 12.8789C21.08 13.2889 20.74 13.6289 20.33 13.6289Z",
    fill: "#6374FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight1);
export default __webpack_public_path__ + "static/media/arrow-right (1).54b1e8ece9ce9b6e873f55651602e8d3.svg";
export { ForwardRef as ReactComponent };